import { TABLE } from 'shared/constans';
import { FC, useEffect } from 'react';
import CreateEditDiscountForm from './create-edit-discount-form/CreateEditDiscountForm';
import { Loading } from 'shared/components';
interface DiscountCreateProps {
  setVisiblePage: (visiblePage: any) => void;
  discountCreate: (values: any) => Promise<void>;
  getAllDiscounts: (page: number | null, page_size: number | null, search: string | null, sort: string | null, sort_dir: string | null, finished: string | null) => Promise<void>;
  allDiscountsData: any;
  loadingAllDiscounts: boolean;
}
const DiscountCreate: FC<DiscountCreateProps> = ({
  setVisiblePage,
  discountCreate,
  getAllDiscounts,
  allDiscountsData,
  loadingAllDiscounts
}) => {

  const handleCancel = () => {
    setVisiblePage(TABLE);
  };

  useEffect(() => {
    getAllDiscounts(null, null, null, null, null, null);
  }, []);

  if(loadingAllDiscounts) {
    return <Loading />;
  }
  return (
    <div className="flex w-full justify-center">
      <CreateEditDiscountForm
        onSubmit={discountCreate}
        onCancel={handleCancel}
        existingDiscounts={allDiscountsData}
      />
    </div>
  );
};

export default DiscountCreate;
